const SECTIONS = [
  {
    icon: '🏥',
    title: 'Cobertura Médica Principal',
    items: [
      'Cada miembro de la familia tiene una cobertura activa de salud.',
      'Confirmé si el plan actual es individual, familiar, grupal o por Marketplace.',
      'Verifiqué si la prima mensual todavía cabe en el presupuesto del hogar.',
      'Revisé el deducible, copagos, coseguro y máximo de gasto de bolsillo.',
      'Ya sé qué hospitales, clínicas y especialistas están dentro de la red.',
      'Confirmé qué hacer en caso de urgencia o emergencia fuera de la red.',
    ],
  },
  {
    icon: '💊',
    title: 'Medicamentos y Atención Continua',
    items: [
      'Cada medicamento importante de la familia está cubierto por el plan.',
      'Revisé si necesito autorizaciones previas para tratamientos, estudios o terapias.',
      'Confirmé cobertura para controles de enfermedades crónicas como diabetes, asma o presión alta.',
      'Revisé si el plan cubre laboratorio, radiografías y estudios especializados.',
    ],
  },
  {
    icon: '👁️',
    title: 'Dental, Visión y Cuidado Preventivo',
    items: [
      'Ya revisé si la familia tiene cobertura dental o necesita un plan adicional.',
      'Confirmé limpieza dental, exámenes, empastes y servicios mayores.',
      'Revisé exámenes de la vista, lentes, monturas y lentes de contacto.',
      'Verifiqué vacunas, chequeos anuales y visitas preventivas para adultos y niños.',
    ],
  },
  {
    icon: '🛡️',
    title: 'Protección Financiera del Hogar',
    items: [
      'Revisé si hay seguro de vida suficiente para proteger a la familia.',
      'Confirmé si alguno de los adultos necesita cobertura por incapacidad o accidentes.',
      'Verifiqué si hay protección para hospitalización, indemnización o enfermedades críticas.',
      'Ya sé cuánto dinero tendría disponible la familia si el principal proveedor no pudiera trabajar.',
    ],
  },
  {
    icon: '👨‍👩‍👧',
    title: 'Niños y Adultos Mayores',
    items: [
      'Verifiqué pediatra, especialistas infantiles y vacunas al día.',
      'Revisé terapias, salud mental, desarrollo infantil o necesidades especiales si aplican.',
      'Confirmé medicamentos, médicos y necesidades de adultos mayores dependientes.',
      'Revisé si algún familiar califica para Medicare, Medicaid o programas de apoyo adicional.',
    ],
  },
  {
    icon: '📁',
    title: 'Documentos y Organización',
    items: [
      'Tengo a la mano tarjetas del seguro, números de póliza y contactos de servicio.',
      'Guardé una lista de medicamentos, alergias y médicos de cada miembro.',
      'Todos saben a qué hospital o clínica ir según el tipo de emergencia.',
      'Los documentos importantes están guardados en un lugar fácil de encontrar.',
    ],
  },
]

const SENALES = [
  'Pagas mucho cada mes y aun así usas poco el plan.',
  'Tus médicos o medicamentos ya no aparecen en la red o formulario.',
  'Tu familia creció, cambió de empleo o cambió de estado migratorio / ingresos.',
  'Tienes deducibles o copagos que te están complicando atenderte.',
]

export function downloadChecklist() {
  const sectionColors = [
    { bg: '#EAF3FB', text: '#1B5E9A' },
    { bg: '#EAF5EE', text: '#1D6A3A' },
    { bg: '#F5EAFB', text: '#6B2D8A' },
    { bg: '#FBF3EA', text: '#8A4A1D' },
    { bg: '#EAF4F5', text: '#1D5F6A' },
    { bg: '#F5EAEB', text: '#8A1D2E' },
  ]

  const sectionsHtml = SECTIONS.map((sec, i) => {
    const color = sectionColors[i]
    const itemsHtml = sec.items
      .map(
        (item) => `
        <div style="display:flex;align-items:flex-start;gap:12px;padding:12px 0;border-bottom:1px solid #E2DDD4;">
          <div style="width:18px;height:18px;border:2px solid #C5C5C5;border-radius:4px;flex-shrink:0;margin-top:2px;"></div>
          <span style="font-size:14px;line-height:1.6;color:#1A2B3C;">${item}</span>
        </div>`,
      )
      .join('')

    return `
      <div style="margin-bottom:28px;">
        <div style="display:flex;align-items:center;gap:14px;padding:16px 20px;background:#FDFBF7;border-radius:12px;border:1px solid #E2DDD4;margin-bottom:0;">
          <div style="width:40px;height:40px;border-radius:10px;display:flex;align-items:center;justify-content:center;font-size:18px;background:${color.bg};color:${color.text};">${sec.icon}</div>
          <div>
            <h3 style="font-family:'Fraunces',Georgia,serif;font-size:17px;font-weight:700;color:#1A2B3C;margin:0;">${sec.title}</h3>
          </div>
        </div>
        <div style="background:#FDFBF7;border-radius:0 0 12px 12px;border:1px solid #E2DDD4;border-top:none;padding:4px 20px 8px;">
          ${itemsHtml}
        </div>
      </div>`
  }).join('')

  const senalesHtml = SENALES.map(
    (s) => `
      <div style="display:flex;align-items:flex-start;gap:10px;padding:10px 0;border-bottom:1px solid rgba(184,50,50,0.12);">
        <div style="width:18px;height:18px;border:2px solid #E8BABA;border-radius:4px;flex-shrink:0;margin-top:2px;"></div>
        <span style="font-size:14px;line-height:1.6;color:#1A2B3C;">${s}</span>
      </div>`,
  ).join('')

  const html = `<!DOCTYPE html>
<html lang="es">
<head>
  <meta charset="UTF-8">
  <meta name="viewport" content="width=device-width, initial-scale=1.0">
  <title>Checklist de Cobertura Familiar — Jesús Silva</title>
  <link href="https://fonts.googleapis.com/css2?family=Fraunces:wght@400;700;900&family=Plus+Jakarta+Sans:wght@300;400;500;600&display=swap" rel="stylesheet">
  <style>
    * { box-sizing: border-box; margin: 0; padding: 0; }
    body { font-family: 'Plus Jakarta Sans', sans-serif; background: #F5F0E8; color: #1A2B3C; padding: 0; }
    @media print {
      body { background: white; }
      .no-print { display: none !important; }
      .hero { break-after: avoid; }
    }
  </style>
</head>
<body>
  <div style="background:#1A2B3C;padding:48px 40px 56px;position:relative;overflow:hidden;">
    <div style="max-width:800px;margin:0 auto;">
      <div style="display:inline-flex;align-items:center;gap:8px;background:rgba(29,106,114,0.25);border:1px solid rgba(29,106,114,0.5);color:#7ECFCF;font-size:11px;letter-spacing:2px;text-transform:uppercase;padding:5px 14px;border-radius:20px;margin-bottom:20px;">
        📋 Cobertura Familiar
      </div>
      <h1 style="font-family:'Fraunces',Georgia,serif;font-size:42px;font-weight:900;color:#fff;line-height:1.1;margin-bottom:14px;">
        Protección <em style="font-style:italic;color:#F5C37A;">completa</em> para tu hogar
      </h1>
      <p style="color:rgba(255,255,255,0.6);font-size:15px;line-height:1.7;max-width:480px;">
        Usa esta checklist para verificar que cada miembro de tu familia tenga la cobertura que necesita.
      </p>
    </div>
  </div>

  <div style="max-width:800px;margin:0 auto;padding:32px 20px 60px;">
    <!-- Datos del Hogar -->
    <div style="background:#FDFBF7;border-radius:16px;padding:24px 28px;border-top:4px solid #C47B2B;margin-bottom:28px;border:1px solid #E2DDD4;">
      <h2 style="font-family:'Fraunces',Georgia,serif;font-size:18px;font-weight:700;margin-bottom:16px;">🏠 Datos del Hogar</h2>
      <div style="display:grid;grid-template-columns:1fr 1fr;gap:14px;">
        <div>
          <label style="display:block;font-size:11px;letter-spacing:1px;text-transform:uppercase;color:#6B7685;margin-bottom:5px;">Responsable principal</label>
          <div style="border:1.5px solid #E2DDD4;border-radius:8px;padding:9px 12px;min-height:36px;background:#F5F0E8;"></div>
        </div>
        <div>
          <label style="display:block;font-size:11px;letter-spacing:1px;text-transform:uppercase;color:#6B7685;margin-bottom:5px;">Número de miembros</label>
          <div style="border:1.5px solid #E2DDD4;border-radius:8px;padding:9px 12px;min-height:36px;background:#F5F0E8;"></div>
        </div>
        <div style="grid-column:1/-1;">
          <label style="display:block;font-size:11px;letter-spacing:1px;text-transform:uppercase;color:#6B7685;margin-bottom:5px;">Médicos principales / pediatra</label>
          <div style="border:1.5px solid #E2DDD4;border-radius:8px;padding:9px 12px;min-height:36px;background:#F5F0E8;"></div>
        </div>
        <div>
          <label style="display:block;font-size:11px;letter-spacing:1px;text-transform:uppercase;color:#6B7685;margin-bottom:5px;">Fecha de última revisión</label>
          <div style="border:1.5px solid #E2DDD4;border-radius:8px;padding:9px 12px;min-height:36px;background:#F5F0E8;"></div>
        </div>
      </div>
    </div>

    ${sectionsHtml}

    <!-- Señales -->
    <div style="background:#FAEAEA;border-radius:14px;border:1px solid #E8BABA;padding:24px 24px 8px;margin-bottom:28px;">
      <h2 style="font-family:'Fraunces',Georgia,serif;font-size:17px;font-weight:700;color:#B83232;margin-bottom:14px;">⚠️ Señales de que tu cobertura necesita revisión</h2>
      ${senalesHtml}
    </div>

    <!-- Pendientes -->
    <div style="background:#FDFBF7;border-radius:14px;padding:24px;border:1px solid #E2DDD4;margin-bottom:28px;">
      <h2 style="font-family:'Fraunces',Georgia,serif;font-size:17px;font-weight:700;margin-bottom:16px;">📝 Pendientes por revisar o corregir</h2>
      <table style="width:100%;border-collapse:collapse;">
        <thead>
          <tr>
            <th style="text-align:left;font-size:11px;letter-spacing:1px;text-transform:uppercase;color:#6B7685;padding:0 0 8px;">Descripción</th>
            <th style="text-align:left;font-size:11px;letter-spacing:1px;text-transform:uppercase;color:#6B7685;padding:0 0 8px;width:100px;">Prioridad</th>
            <th style="text-align:left;font-size:11px;letter-spacing:1px;text-transform:uppercase;color:#6B7685;padding:0 0 8px;width:110px;">Fecha</th>
          </tr>
        </thead>
        <tbody>
          ${[1, 2, 3]
            .map(
              () => `
            <tr>
              <td style="padding:6px 8px 6px 0;border-bottom:1px solid #E2DDD4;"><div style="border:1.5px solid #E2DDD4;border-radius:6px;padding:7px 10px;min-height:32px;background:#F5F0E8;"></div></td>
              <td style="padding:6px 8px 6px 0;border-bottom:1px solid #E2DDD4;"><div style="border:1.5px solid #E2DDD4;border-radius:6px;padding:7px 10px;min-height:32px;background:#F5F0E8;"></div></td>
              <td style="padding:6px 0 6px 0;border-bottom:1px solid #E2DDD4;"><div style="border:1.5px solid #E2DDD4;border-radius:6px;padding:7px 10px;min-height:32px;background:#F5F0E8;"></div></td>
            </tr>
          `,
            )
            .join('')}
        </tbody>
      </table>
    </div>

    <!-- Nota -->
    <div style="background:#FBF3E6;border:1px solid #E8CFA0;border-radius:12px;padding:18px 20px;font-size:13px;color:#7A4E10;line-height:1.7;display:flex;gap:10px;align-items:flex-start;">
      <span>ℹ️</span>
      <span>Esta checklist es informativa y sirve como apoyo para organizar la protección del hogar. La cobertura ideal depende de la edad, salud, presupuesto, médicos, medicamentos y necesidades de cada familia.</span>
    </div>

    <div style="text-align:center;margin-top:32px;font-size:13px;color:#6B7685;">
      Preparado por <strong style="color:#C47B2B;">Jesús Silva</strong> — Agente de Seguros de Protección Integral<br>
      <span style="font-size:12px;">WhatsApp: (346) 902-2090 · jsilvainsurance@gmail.com</span>
    </div>
  </div>
</body>
</html>`

  const blob = new Blob([html], { type: 'text/html;charset=utf-8' })
  const url = URL.createObjectURL(blob)
  const a = document.createElement('a')
  a.href = url
  a.download = 'Checklist-Cobertura-Familiar.html'
  document.body.appendChild(a)
  a.click()
  document.body.removeChild(a)
  URL.revokeObjectURL(url)
}
